var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipettes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.6,35.5c0,0.2,0.1,0.3,0.1,0.4l1.5,1.5H10l2.5-2.6c1.4,0.5,2.9,0.2,3.9-0.9l11-11.1l2.2,2.1L30,25 c0.2,0,0.3-0.1,0.4-0.2l2-2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2,0-0.3-0.1-0.4L30.1,20l6.2-6.2c1.1-1,1.4-2.6,0.8-4 c-0.5-1.4-1.8-2.3-3.3-2.3c-1,0-1.9,0.4-2.6,1.1L25,14.9l-2.2-2.2h-0.7l-2,2C20,14.7,20,14.9,20,15c0,0.1,0,0.2,0.1,0.3l2.2,2.2 L11.1,28.7c-1,1-1.4,2.5-0.9,3.8l-2.6,2.6V35.5z M21.3,15l1.3-1.3l8.7,8.8L30,23.9l-2.1-2.2l-4.5-4.5L21.3,15z M11.3,33 c0.1-0.2,0.1-0.4,0.1-0.6c-0.5-1-0.3-2.2,0.5-3l0.2-0.3l1.6,1.7l0.7-0.7l-1.6-1.7l0.8-0.7l1.1,1.1l0.7-0.7L14.3,27l0.8-0.7l1.6,1.6 l0.7-0.7l-1.6-1.6l0.8-0.8l1.1,1.1l0.7-0.7L17.3,24l0.8-0.8l1.6,1.6l0.7-0.7l-1.6-1.6l0.8-0.8l1.1,1.1l0.7-0.7L20.3,21l0.8-0.8 l1.6,1.6l0.7-0.7l-1.6-1.6l1.3-1.3l3.7,3.8L15.6,33.2c-0.8,0.8-2.1,1-3.1,0.5H12l-2.5,2.6l-0.8-0.8L11.3,33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12,33.7h0.5c1,0.5,2.3,0.3,3.1-0.5L26.8,22L23,18.2l-1.3,1.3l1.6,1.6l-0.7,0.7L21,20.2L20.3,21l1.1,1.1 l-0.7,0.7l-1.1-1.1l-0.8,0.8l1.6,1.6l-0.7,0.7L18,23.2L17.3,24l1.1,1.1l-0.7,0.7l-1.1-1.1l-0.8,0.8l1.6,1.6l-0.7,0.7L15,26.2 L14.3,27l1.1,1.2l-0.7,0.7l-1.1-1.1l-0.8,0.7l1.6,1.7l-0.7,0.7L12,29.2l-0.2,0.3c-0.8,0.8-1,2-0.5,3c0,0.2,0,0.4-0.1,0.6l-2.5,2.4 l0.8,0.8L12,33.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "27.8,21.7 30,23.9 31.3,22.5 22.5,13.7 21.3,15 23.3,17.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipettes);
export default __webpack_public_path__ + "static/media/pipettes.20b283d84fbffbe6fd65f8fed5871d58.svg";
export { ForwardRef as ReactComponent };